export const externalLicensesPerPage = 20;
